import { lazy } from "react";
import { RouteObject } from "react-router-dom";

import { RouterGuard } from "../guard";

const Login = lazy(() => import("@/pages/login"));

const Callback = lazy(() => import("@/pages/login/callback"));

const Signin = lazy(() => import("@/pages/mobile/login-mobile"));

export const login: RouteObject[] = [
  {
    path: "/login",
    element: <RouterGuard element={<Login />} valid={false} />,
  },
  {
    path: "/signin",
    element: <RouterGuard element={<Signin />} valid={false} />,
  },
  {
    path: "/callback",
    element: <RouterGuard element={<Callback />} valid={false} />,
  },
];
